const PRODUCTION_API = "https://dsitesolution-api.onrender.com";

function isLocalDevApiUrl(url) {
  return /^https?:\/\/(127\.0\.0\.1|localhost)(:\d+)?$/i.test(url);
}

function readEnvUrl() {
  const raw = process.env.REACT_APP_BACKEND_URL || process.env.REACT_APP_API_URL || "";
  const trimmed = raw.trim().replace(/\/$/, "");
  if (!trimmed) return null;
  if (process.env.NODE_ENV === "production" && isLocalDevApiUrl(trimmed)) {
    return null;
  }
  return trimmed;
}

function temporaryTunnelOrigin() {
  if (typeof window === "undefined") return null;
  const host = window.location.hostname || "";
  if (host.endsWith(".trycloudflare.com") || host.endsWith(".ngrok-free.app") || host.endsWith(".ngrok.io")) {
    return window.location.origin.replace(/\/$/, "");
  }
  return null;
}

/** Backend origin used by axios/fetch. */
export const API_BASE_URL = temporaryTunnelOrigin() || readEnvUrl() || PRODUCTION_API;

export const BACKEND_BASE = API_BASE_URL;

/** FastComet static-only deploy: marketing pages live, API features show graceful notices. */
export const STATIC_FRONTEND_MODE =
  process.env.REACT_APP_STATIC_FRONTEND === "true" ||
  process.env.REACT_APP_DISABLE_BACKEND === "true";

export const API_REQUEST_TIMEOUT_MS = Number(process.env.REACT_APP_API_TIMEOUT_MS || 12000);

/** Customer signup POST only — longer wait for mobile / Render cold start. */
export const SIGNUP_REQUEST_TIMEOUT_MS = Number(process.env.REACT_APP_SIGNUP_TIMEOUT_MS || 15000);

/** Signup uses a single POST — no automatic warm/retry loop. */
export const SIGNUP_MAX_RETRIES = Number(process.env.REACT_APP_SIGNUP_MAX_RETRIES || 0);

export const DEFAULT_STATIC_OG_IMAGE = "/brand/og-default.png";

export function isApiNetworkError(err) {
  return !err?.response;
}

export function isAxiosTimeoutError(err) {
  if (!err) return false;
  if (err.code === "ECONNABORTED") return true;
  if (err.name === "AbortError") return true;
  const msg = String(err.message || "").toLowerCase();
  return msg.includes("timeout");
}

export function getApiUnavailableMessage() {
  return "서버 연결 준비 중입니다. 홈페이지는 정상 이용 가능하며, 로그인·문의·관리 기능은 백엔드 연결 후 제공됩니다.";
}

/** FastComet 정적 배포 후 이전 CMS 미디어 URL이 남아 있을 때 브라우저에서 지울 항목 안내 */
export const STATIC_DEPLOY_LOCALSTORAGE_CACHE_NOTICE =
  "이전 개발/관리자 화면에서 저장된 CMS 캐시(localStorage 키: dsite_cms_cache_v12 및 dsite_cms_cache_v*)가 오래된 /api/uploads 경로를 가리키면 About 영상·로고 등이 깨질 수 있습니다. DevTools → Application → Local Storage에서 해당 키를 삭제하거나, 시크릿 창으로 확인하세요.";

export function formatApiUserMessage(err, fallback = "요청 처리 중 오류가 발생했습니다.") {
  if (isApiNetworkError(err)) return getApiUnavailableMessage();
  return fallback;
}
